// extracted by mini-css-extract-plugin
export default {"progress-bar":"progression_progress-bar__5Rvy2","progress-bar__state":"progression_progress-bar__state__8Tjww"};